import { useEffect } from 'react';
import { recordSession } from '@coparent/shared/src/services/analyticsService';

const storage = {
  get: async (key) => {
    try {
      return typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(key) : null;
    } catch {
      return null;
    }
  },
  set: async (key, value) => {
    try {
      if (typeof sessionStorage !== 'undefined') sessionStorage.setItem(key, value);
    } catch {
      // Silent — storage failures should never break the app.
    }
  },
};

/**
 * Fire a session ping once the user's uid is known. Runs fire-and-forget;
 * failures are logged but not surfaced. Idempotent per day.
 */
export default function useSessionPing(uid) {
  useEffect(() => {
    if (!uid) return;
    recordSession({ uid, platform: 'web', storage });
  }, [uid]);
}
